import {
    Component,
    EventEmitter,
    Inject,
    Input,
    OnInit,
    Output,
} from "@angular/core";
import { UserDm, DismissedBanner } from "@/_models";
import {
    AuthenticationService,
    USER_IS_AT_LEAST_ADMIN,
    USER_IS_OWNER,
    UserService,
    SubscriptionService,
} from "@/_services";
import { MenuSection } from "@/_models/menu-item";
import { isAsapAccount } from "@/_models/account.interface";
import { shareReplay, map } from "rxjs/operators";
import { Observable } from "rxjs";
import { MenuService } from "@/_services/menu.service";
import UserModel = UserDm.UserModel;
import { OnboardingGuideService } from "@/_services/onboarding-guide.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { SidebarStateService } from "../../shared/responsive/sidebar-state.service";

@UntilDestroy()
@Component({
    selector: "app-desktop-menu",
    templateUrl: "./desktop-menu.component.html",
    styleUrls: ["./desktop-menu.component.scss"],
})
export class DesktopMenuComponent implements OnInit {
    showForms = true;
    hasLinkedLogins = false;
    isAsap = false;

    @Output() enterEdit: EventEmitter<void> = new EventEmitter<void>();
    @Input() showAccountLink = false;

    asapFormId$: Observable<string | null>;
    currentUser$: Observable<UserModel>;
    mainMenu$: Observable<MenuSection>;
    formMenu$: Observable<MenuSection>;
    hasNotDismissedBanner$: Observable<boolean>;
    isTrialActive$: Observable<boolean>;

    constructor(
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private menuService: MenuService,
        private onboardingGuideService: OnboardingGuideService,
        private subscriptionService: SubscriptionService,
        public sidebarStateService: SidebarStateService,
        @Inject(USER_IS_OWNER)
        public isOwner$: Observable<boolean>,
        @Inject(USER_IS_AT_LEAST_ADMIN)
        public isAtLeastAdmin$: Observable<boolean>,
    ) {
        this.hasLinkedLogins = this.authenticationService.hasLinkedLogins();
    }

    get isCollapsed(): boolean {
        return this.sidebarStateService.isCollapsed;
    }

    ngOnInit() {
        this.currentUser$ = this.userService
            .getCurrentUserAsync()
            .pipe(shareReplay());

        this.hasNotDismissedBanner$ = this.currentUser$.pipe(
            map((user) => {
                const dismissed = user?.dismissedBanners || [];
                return !dismissed.includes(DismissedBanner.OnboardingGuide);
            }),
            shareReplay(1),
        );

        this.currentUser$.pipe(untilDestroyed(this)).subscribe((user) => {
            this.isAsap = isAsapAccount(user.account);
        });

        this.mainMenu$ = this.menuService.createDesktopMenu();
        this.formMenu$ = this.menuService.createFormMenu();

        this.asapFormId$ = this.onboardingGuideService.asapFormId$;
        this.isTrialActive$ = this.subscriptionService.isTrialAccount();
    }

    toggleCollapse() {
        this.showForms = !this.showForms;
    }
}
